import script from "./ai-menu-initing.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-menu-initing.vue?vue&type=script&setup=true&lang=js"

import "./ai-menu-initing.vue?vue&type=style&index=0&id=9352d278&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9352d278"]])

export default __exports__